<script setup lang="ts">
import {
  useSettingStore,
} from 'pinia-store'
import { Error } from '@ui'
import type { NuxtError } from '#app'

defineProps({
  error: Object as () => NuxtError,
})

const useSetting = useSettingStore()

const component = shallowRef({})
const isLoading = ref(false)

try {
  component.value = await resolveComponent('ComponentsError')
}
catch (e) {
  component.value = Error
}
</script>

<template>
  <main
    :data-version="useSetting.version"
    class="main h-[100vh] flex flex-col"
  >
    <component :is="isLoading ? ('loading') : component" />
  </main>
</template>
